import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutAction } from '../../../redux/actions/authActions';
import Button from '../../ui/button';

import { useTranslation } from 'react-i18next';

const LogoutModal = ({ isOpen, onClose }) => {
    const {t }= useTranslation('common');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userData = useSelector(state => state.auth?.userData || null);


    const closeModal = (refresh=false) => {
        onClose(refresh);
    };
    const logout = async () => {
        localStorage.removeItem('user')
        localStorage.setItem('site', JSON.stringify({ "label": null, "value": null }))
        localStorage.removeItem('site')
        localStorage.removeItem('company')
        localStorage.removeItem('accessToken')
        document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        await dispatch(logoutAction());

        navigate("/signin")
        onClose(true);
    };

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
            <div className="grid space-x-6 max-lg:grid-cols-1 grid-cols-2 w-auto m-2 bg-white max-md:p-3 p-8 rounded-3xl shadow-lg">
                <p className="flex justify-center col-span-2 text-xl text-[#4C4C66] font-bold mb-10">{t('logout')}</p>
                <p className="flex justify-center col-span-2 text-md text-[#4C4C66] font-normal mb-4">{t('are_you_sure_that_you_want_to_logout')}</p>
                <div className='col-span-2 flex justify-center mt-10 space-x-5'>
                    <Button type="reset" onClick={closeModal} size="large" color="cancel">{t('cancel')}</Button>
                    <Button type="submit" size="large" onClick={logout}>{t('logout')}</Button>
                </div>
            </div>
        </div>
    );
};

export default LogoutModal;
